module.exports = __webpack_public_path__ + "img/news-slider3-en.d20944e5.jpg";